// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__15gQK","title":"ClientReferral_title__3QUfT","itemText":"ClientReferral_itemText__3ABMa"};